import React from 'react';
import styled from 'styled-components';
import theme from '../../styles/theme.styles';

import settingButtonTypes from './SettingsButtons.types';

function Icon({ type }) {
  switch (type) {
    case settingButtonTypes.LOGOUT:
      return (
        <IconWrapper>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16 17L21 12L16 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M21 12H9" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </IconWrapper>
      );
    case settingButtonTypes.CHANGE_PASSWORD:
      return (
        <IconWrapper>
          <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M24.6223 8.27212C24.5588 8.15282 24.4503 8.06332 24.3206 8.02316C24.1908 7.98299 24.0504 7.99543 23.9298 8.05774C23.8093 8.12006 23.7184 8.2272 23.6771 8.35578C23.6359 8.48436 23.6474 8.62395 23.7094 8.74407C24.8139 10.8379 25.2141 13.2279 24.8514 15.564C24.4887 17.9001 23.3821 20.0595 21.6938 21.7256C17.3342 26.0548 10.2397 26.0562 5.87824 21.7251C5.80626 21.6536 5.71456 21.605 5.61473 21.5853C5.5149 21.5656 5.41143 21.5757 5.31741 21.6144C5.22339 21.6532 5.14305 21.7187 5.08655 21.8028C5.03005 21.8869 4.99993 21.9857 5 22.0868V25.0247C5 25.1602 5.05421 25.2902 5.1507 25.386C5.24719 25.4818 5.37806 25.5357 5.51452 25.5357C5.65097 25.5357 5.78184 25.4818 5.87833 25.386C5.97482 25.2902 6.02903 25.1602 6.02903 25.0247V23.2408C8.20365 25.0158 10.9288 25.9905 13.7437 25.9999C16.5585 26.0094 19.2903 25.0531 21.4769 23.2927C23.6636 21.5323 25.171 19.0759 25.7441 16.3389C26.3172 13.6019 25.921 10.7524 24.6223 8.27212V8.27212Z" fill="white" stroke="white" />
            <path d="M5.31553 5.27079C9.67412 0.938854 16.7646 0.939308 21.1223 5.27033C21.1941 5.34193 21.2857 5.39071 21.3855 5.4105C21.4853 5.43029 21.5887 5.4202 21.6827 5.38151C21.7767 5.34281 21.8571 5.27725 21.9135 5.19313C21.97 5.10902 22.0001 5.01013 22 4.909V1.97022C22 1.83466 21.9458 1.70465 21.8494 1.60879C21.7529 1.51294 21.6222 1.45908 21.4858 1.45908C21.3494 1.45908 21.2186 1.51294 21.1222 1.60879C21.0257 1.70465 20.9715 1.83466 20.9715 1.97022V3.75466C16.1819 -0.16558 9.0649 0.0981615 4.58849 4.54766C2.74574 6.36749 1.5379 8.7262 1.14202 11.2781C0.746135 13.8299 1.18302 16.4407 2.38865 18.7278C2.45215 18.8471 2.56057 18.9367 2.69024 18.9768C2.81991 19.017 2.9603 19.0046 3.08078 18.9422C3.20125 18.8799 3.29203 18.7727 3.33331 18.6441C3.37458 18.5155 3.36299 18.3759 3.30107 18.2557C2.19717 16.1614 1.79717 13.7706 2.15969 11.4339C2.52221 9.09716 3.62818 6.93728 5.31553 5.27079V5.27079Z" fill="white" stroke="white" />
            <path d="M6.5 19.0737V13.4009C6.50093 13.179 6.59826 12.9551 6.78958 12.7818C6.98257 12.6069 7.25363 12.5009 7.54559 12.5H19.285C19.577 12.5009 19.848 12.6068 20.041 12.7817C20.2323 12.9551 20.3296 13.1789 20.3306 13.4008V19.0738C20.3296 19.2958 20.2323 19.5195 20.041 19.6929C19.848 19.8678 19.5769 19.9737 19.2849 19.9746H7.5457C7.25369 19.9737 6.98259 19.8678 6.78957 19.6929C6.59825 19.5195 6.50093 19.2957 6.5 19.0737ZM15.825 16.2368V16.2373C15.825 16.5647 15.9324 16.88 16.1264 17.1432C16.32 17.4057 16.5897 17.6034 16.8962 17.7185C17.2025 17.8335 17.5372 17.863 17.8597 17.8048C18.1822 17.7467 18.4845 17.6022 18.7262 17.3832C18.9684 17.1637 19.1399 16.8778 19.21 16.5585C19.2802 16.2386 19.2436 15.9076 19.1075 15.6099C18.9718 15.313 18.7458 15.0674 18.4661 14.898C18.1867 14.7288 17.8628 14.6409 17.5349 14.6409V15.1409L17.5345 14.6409C17.0962 14.6413 16.6674 14.7987 16.3439 15.0918C16.0189 15.3864 15.8254 15.7969 15.825 16.2368ZM11.7053 16.2368V16.2373C11.7053 16.5647 11.8127 16.88 12.0068 17.1432C12.2003 17.4057 12.47 17.6034 12.7765 17.7185C13.0829 17.8335 13.4176 17.863 13.74 17.8048C14.0626 17.7467 14.3649 17.6022 14.6066 17.3832C14.8488 17.1637 15.0203 16.8778 15.0903 16.5585C15.1606 16.2386 15.1239 15.9076 14.9879 15.6099C14.8522 15.313 14.6262 15.0674 14.3465 14.898C14.0671 14.7288 13.7431 14.6409 13.4153 14.6409V15.1409L13.4149 14.6409C12.9766 14.6413 12.5477 14.7987 12.2243 15.0918C11.8993 15.3864 11.7058 15.7969 11.7053 16.2368ZM7.58571 16.2368V16.2373C7.58571 16.5647 7.6931 16.88 7.88718 17.1432C8.08072 17.4057 8.35041 17.6034 8.65691 17.7185C8.96324 17.8335 9.29793 17.863 9.6204 17.8048C9.94292 17.7467 10.2452 17.6022 10.487 17.3832C10.7292 17.1637 10.9006 16.8778 10.9707 16.5585C11.0409 16.2386 11.0043 15.9076 10.8682 15.6099C10.7326 15.313 10.5066 15.0674 10.2268 14.898C9.94743 14.7288 9.62351 14.6409 9.29565 14.6409V15.1409L9.29522 14.6409C8.85697 14.6413 8.4281 14.7987 8.10468 15.0918C7.77964 15.3864 7.58618 15.7969 7.58571 16.2368Z" fill="white" stroke="white" />
            <path d="M18.5933 11.356V9.50543C18.5933 8.31051 18.0352 7.16454 17.0419 6.31961C16.0486 5.47468 14.7014 5 13.2966 5C11.8919 5 10.5447 5.47468 9.55135 6.31961C8.55804 7.16454 8 8.31051 8 9.50543V11.356H9.19605V9.50543C9.19605 8.58033 9.62808 7.69313 10.3971 7.03899C11.1661 6.38486 12.2091 6.01736 13.2967 6.01736C14.3842 6.01736 15.4272 6.38486 16.1962 7.03899C16.9652 7.69313 17.3973 8.58033 17.3973 9.50543V11.356H18.5933Z" fill="white" stroke="white" />
          </svg>

        </IconWrapper>
      );
    case settingButtonTypes.DELETE:
      return (
        <IconWrapper>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 6H5H21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </IconWrapper>
      );
    case settingButtonTypes.LEGAL:
      return (
        <IconWrapper>
          <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.4011 12.873C20.4814 14.1758 22.3523 14.793 23.9763 14.6484C24.2568 20.2832 22.1528 23.6113 18.4229 25C14.8194 23.6992 12.6936 20.5078 12.8457 14.5625C14.8465 14.7098 16.83 14.1066 18.4011 12.873V12.873ZM13.4266 3.36914L17.52 7.1582H13.4266V3.36914ZM5.20211 11.9375H13.474C14.0153 11.9375 14.0864 12.6699 13.7347 12.9141C13.5708 12.9434 13.4088 12.9687 13.2448 12.9902H5.20804C4.57189 12.9902 4.57189 11.9492 5.20804 11.9395L5.20211 11.9375ZM5.20211 15.207H10.9689C10.9847 15.5664 11.0104 15.916 11.042 16.2578H5.20804C4.56794 16.2578 4.57584 15.207 5.20804 15.207H5.20211ZM5.20211 18.4766H11.368C11.443 18.8379 11.528 19.1895 11.6228 19.5273H5.20804C4.56794 19.5273 4.57584 18.4766 5.20804 18.4766H5.20211ZM5.20211 8.66797H9.96134C10.6014 8.66797 10.5935 9.7168 9.96134 9.7168H5.20804C4.56794 9.7168 4.57387 8.66797 5.20804 8.66797H5.20211ZM5.20211 5.62695H7.81979C8.45001 5.62695 8.45791 6.67578 7.81979 6.67578H5.20804C4.56794 6.67578 4.57584 5.62695 5.20804 5.62695H5.20211ZM19.7979 7.70312C19.7982 7.55632 19.7499 7.41345 19.6604 7.29635C19.5708 7.17925 19.445 7.09437 19.302 7.05469L13.2725 1.24804C13.2088 1.17043 13.1284 1.10787 13.0371 1.06495C12.9459 1.02203 12.846 0.999836 12.745 0.999997H2.22488C1.90002 0.999997 1.58847 1.12758 1.35876 1.35467C1.12905 1.58177 1 1.88977 1 2.21093L1 22.9434C1.00052 23.2644 1.12974 23.5721 1.35933 23.7991C1.58893 24.026 1.90018 24.1538 2.22488 24.1543H14.039C13.6672 23.7313 13.3315 23.2786 13.0354 22.8008H2.36712V2.3457H12.0634V7.83594C12.0631 7.9251 12.0807 8.01344 12.115 8.09589C12.1493 8.17835 12.1998 8.25329 12.2635 8.31643C12.3272 8.37957 12.4028 8.42967 12.4861 8.46385C12.5694 8.49803 12.6587 8.51562 12.7489 8.51562H18.4288V10.8301C18.8924 11.1191 19.3488 11.3828 19.7979 11.6211V7.70312ZM18.4446 14.8008C19.8651 15.6895 21.1472 16.1113 22.2476 16.0117C22.4452 19.8555 21.003 22.125 18.4604 23.0703C18.4443 23.0653 18.4285 23.0594 18.413 23.0527V14.8262L18.4446 14.8008V14.8008ZM18.4031 13.5684C20.2444 14.7227 21.9098 15.2695 23.3421 15.1406C23.591 20.1289 21.728 23.0742 18.4248 24.3027C15.2244 23.1523 13.3456 20.3359 13.4858 15.0625C15.2569 15.1929 17.0127 14.6587 18.4031 13.5664V13.5684Z" fill="white" stroke="white" />
          </svg>
        </IconWrapper>
      );
    default:
      return null;
  }
}

function SettingButtonInside({
  type, heading, line2,
}) {
  return (
    <StyledSettingsButton>
      {type === settingButtonTypes.SHARE}
      <div>
        <SettingsHeading>
          {heading}

        </SettingsHeading>
        {line2 && <SettingsLine2>{line2}</SettingsLine2>}
      </div>

      {type === settingButtonTypes.LOGOUT && <Icon type={type} />}
      {type === settingButtonTypes.DELETE && <Icon type={type} />}
      {type === settingButtonTypes.CHANGE_PASSWORD && <Icon type={type} />}
      {type === settingButtonTypes.LEGAL && <Icon type={type} />}

    </StyledSettingsButton>
  );
}

function SettingsButton({
  type, heading, line2, switchSate, onClick,
}) {
  // const { type, heading, line2, switchSate } = props
  return (
    <NavDiv
      onClick={onClick}
      onKeyDown={onClick}
      role="button"
    >
      <SettingButtonInside
        type={type}
        heading={heading}
        line2={line2}
        switchSate={switchSate}
      />
    </NavDiv>
  );
}

export default SettingsButton;

const NavDiv = styled.div`

`;
const IconWrapper = styled.div`
  /* min-height: 68px; */
  display: flex;
  flex-direction: row;
  align-items: center;
  float: right;
  position: absolute;
  right: 20px;
  top: 20px;
`;
const StyledSettingsButton = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    background-color: ${theme.colors.transparentWhite2};
    border-radius: 12px;
    padding: 15px;
    margin-bottom: 15px;
    cursor: pointer;
    position: relative;
`;
const SettingsHeading = styled.h1`
    font-family: ${theme.fonts.gotham13Regular};
    font-style: normal;
    font-size: 17px;
    display: flex;
    flex-direction: column;
    flex: 1;
    line-height: 24px;
    color: ${theme.colors.white};
    text-align: left;
`;
const SettingsLine2 = styled.div`
    font-family: ${theme.fonts.gotham13Regular};
    font-style: normal;
    font-size: 15px;
    display: flex;
    flex-direction: column;
    flex: 1;
    width: 100%; 
    line-height: 18px;
    color: ${theme.colors.transparentWhite6};
    text-align: left;
`;
